module.exports = __webpack_public_path__ + "img/ch68.9e2f2a02.jpg";